declare global {
  interface Window {
    OnetrustActiveGroups?: string
  }
}

/* eslint-disable */
export function event(eventName: string, eventCategory: string, eventAction: string, eventLabel: string, consentCategory: string = 'C0002') {
  if (!window.dataLayer) {
    console.log('Can\'t find window.dataLayer.');
    return;
  }

  const { config } = window.appAirDrop;
  const envCode = config.RUNTIME_ENV || null;
  const oneTrustEnabled = config.enableCookieConsent && config.oneTrustSiteId;
  const consented = !oneTrustEnabled || (window.OnetrustActiveGroups || '').includes(',' + consentCategory + ',');
  if (!consented) {
    return;
  }

  const localDt = new Date();
  const transactionLocalDt = '{year}-{month}-{date}T{hours}:{minutes}:{seconds}.{milliseconds}'
    .replace('{year}', `${localDt.getFullYear()}`)
    .replace('{month}', `00${(localDt.getMonth() + 1)}`.slice(-2))
    .replace('{date}', `00${localDt.getDate()}`.slice(-2))
    .replace('{hours}', `00${localDt.getHours()}`.slice(-2))
    .replace('{minutes}', `00${localDt.getMinutes()}`.slice(-2))
    .replace('{seconds}', `00${localDt.getSeconds()}`.slice(-2))
    .replace('{milliseconds}', `000${localDt.getMilliseconds()}`.slice(-3));
  const eventBody = {
    environment_code: envCode,
    event: eventName,
    event_category: eventCategory,
    event_action: eventAction,
    event_label: eventLabel,
    client_id: config.CLIENT_ID,
    transaction_dt: localDt.toISOString(),
    transaction_local_dt: transactionLocalDt,
    event_timestamp: localDt.getTime(),
  };
  window.dataLayer.push(eventBody);
}
